import React, { useState } from 'react';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
const ShootingChart = () => {
  const [activeQuarters, setActiveQuarters] = useState(['Q1', 'Q2', 'Q3', 'Q4']);
  const homePlayers = [{
    name: 'Jalen Brunson',
    number: '11'
  }, {
    name: 'Donte DiVincenzo',
    number: '0'
  }, {
    name: 'Josh Hart',
    number: '3'
  }, {
    name: 'Julius Randle',
    number: '30'
  }, {
    name: 'Mitchell Robinson',
    number: '23'
  }, {
    name: 'Immanuel Quickley',
    number: '5'
  }, {
    name: 'Isaiah Hartenstein',
    number: '55'
  }, {
    name: 'Miles McBride',
    number: '2'
  }];
  const awayPlayers = [{
    name: 'LeBron James',
    number: '23'
  }, {
    name: 'Anthony Davis',
    number: '3'
  }, {
    name: "D'Angelo Russell",
    number: '1'
  }, {
    name: 'Austin Reaves',
    number: '15'
  }, {
    name: 'Rui Hachimura',
    number: '28'
  }, {
    name: 'Jarred Vanderbilt',
    number: '2'
  }, {
    name: 'Taurean Prince',
    number: '12'
  }, {
    name: 'Gabe Vincent',
    number: '7'
  }];
  const [selectedHomePlayers, setSelectedHomePlayers] = useState<string[]>(homePlayers.map(player => player.name));
  const [selectedAwayPlayers, setSelectedAwayPlayers] = useState<string[]>(awayPlayers.map(player => player.name));
  const [homeFilters, setHomeFilters] = useState({
    madeShots: true,
    missedShots: true,
    twoPoints: true,
    threePoints: true
  });
  const [awayFilters, setAwayFilters] = useState({
    madeShots: true,
    missedShots: true,
    twoPoints: true,
    threePoints: true
  });
  const quarters = ['Q1', 'Q2', 'Q3', 'Q4'];
  const toggleQuarter = (quarter: string) => {
    setActiveQuarters(prev => prev.includes(quarter) ? prev.filter(q => q !== quarter) : [...prev, quarter]);
  };
  const toggleHomePlayer = (name: string) => {
    setSelectedHomePlayers(prev => prev.includes(name) ? prev.filter(p => p !== name) : [...prev, name]);
  };
  const toggleAwayPlayer = (name: string) => {
    setSelectedAwayPlayers(prev => prev.includes(name) ? prev.filter(p => p !== name) : [...prev, name]);
  };
  return <div className="bg-white rounded-lg shadow-md p-6" data-id="element-879" data-mp="1ujmqxe075gq9">
      <h2 className="text-xl font-bold mb-6" data-id="element-880" data-mp="xx191ujcl2za">Shooting Chart</h2>
      <div className="flex gap-6" data-id="element-881" data-mp="11wtn2mrig1c1">
        <div className="w-56 shrink-0" data-id="element-882" data-mp="11y4rmoss5d47">
          <div className="font-semibold text-red-600 mb-3" data-id="element-883" data-mp="11uz43dzsujal">New York Knicks</div>
          <div className="space-y-2" data-id="element-884" data-mp="16ubm9lfq726u">
            {homePlayers.map(player => <label key={player.number} className="flex items-center space-x-3 cursor-pointer" data-id="element-885" data-mp="1bopjzuhv1leo">
                <input type="checkbox" checked={selectedHomePlayers.includes(player.name)} onChange={() => toggleHomePlayer(player.name)} className="rounded border-gray-300 text-red-600 focus:ring-red-500" data-id="element-886" data-mp="j6kb4l5x8v75" />
                <span className="text-sm" data-id="element-887" data-mp="1p53ckati8hz">
                  #{player.number} {player.name}
                </span>
              </label>)}
          </div>
        </div>
        <div className="flex-1" data-id="element-888" data-mp="3tv0gchtu1y3d">
          <div className="flex justify-center gap-4 mb-4" data-id="element-889" data-mp="3oucsg50whxdd">
            {quarters.map(quarter => <label key={quarter} className="flex items-center space-x-2 cursor-pointer" data-id="element-890" data-mp="3k2mbvhbdeddi">
                <input type="checkbox" checked={activeQuarters.includes(quarter)} onChange={() => toggleQuarter(quarter)} className="rounded border-gray-300 text-blue-600 focus:ring-blue-500" data-id="element-891" data-mp="3f4ks0u64ea0z" />
                <span className="text-sm font-medium" data-id="element-892" data-mp="315bhob4lia4x">{quarter}</span>
              </label>)}
          </div>
          <div className="border rounded-lg p-4 mb-4" data-id="element-893" data-mp="151x8twaiav0t">
            <div className="relative w-full" style={{
            paddingBottom: '50%'
          }} data-id="element-894" data-mp="1938ob8zo1zva">
              <svg viewBox="0 0 1000 500" className="absolute inset-0 w-full h-full" style={{
              backgroundColor: '#fff'
            }} data-id="element-895" data-mp="v97zb6yinr84">
                <rect x="0" y="0" width="1000" height="500" fill="none" stroke="#000" strokeWidth="2" data-id="element-896" data-mp="qc7s2spxkiff" />
                <line x1="500" y1="0" x2="500" y2="500" stroke="#000" strokeWidth="2" data-id="element-897" data-mp="hcksmcgrhmp0" />
                <circle cx="500" cy="250" r="60" fill="none" stroke="#000" strokeWidth="2" data-id="element-898" data-mp="2bp27avnjbei1" />
                <rect x="0" y="175" width="190" height="150" fill="none" stroke="#000" strokeWidth="2" data-id="element-899" data-mp="2gsbd1jbefkc0" />
                <path d="M 0,250 a 60,60 0 0,0 60,60 a 60,60 0 0,0 -60,-60" fill="none" stroke="#000" strokeWidth="2" data-id="element-900" data-mp="34jh1gmvenkxx" />
                <rect x="810" y="175" width="190" height="150" fill="none" stroke="#000" strokeWidth="2" data-id="element-901" data-mp="3dkyiq8kjtso7" />
                <path d="M 1000,250 a 60,60 0 0,1 -60,60 a 60,60 0 0,1 60,-60" fill="none" stroke="#000" strokeWidth="2" data-id="element-902" data-mp="1j8qhyeljqhki" />
                <path d="M 0,75 Q 150,75 150,250 Q 150,425 0,425" fill="none" stroke="#000" strokeWidth="2" data-id="element-903" data-mp="3ec6korjsfpbq" />
                <path d="M 1000,75 Q 850,75 850,250 Q 850,425 1000,425" fill="none" stroke="#000" strokeWidth="2" data-id="element-904" data-mp="3oaclt6xrsrfj" />
                <circle cx="300" cy="150" r="4" fill="#3b82f6" opacity="0.6" data-id="element-905" data-mp="62dhzvo4tmpm" />
                <circle cx="320" cy="180" r="4" fill="#3b82f6" opacity="0.6" data-id="element-906" data-mp="60ahuit9md76" />
                <circle cx="280" cy="200" r="4" fill="#3b82f6" opacity="0.6" data-id="element-907" data-mp="atlskv177e4d" />
                <circle cx="350" cy="160" r="4" fill="#3b82f6" opacity="0.6" data-id="element-908" data-mp="fr53bkyot8rk" />
                <circle cx="400" cy="250" r="4" fill="#3b82f6" opacity="0.6" data-id="element-909" data-mp="krt5n2sd9c13" />
                <circle cx="380" cy="300" r="4" fill="#3b82f6" opacity="0.6" data-id="element-910" data-mp="osuvit0e8bqe" />
                <circle cx="290" cy="350" r="4" fill="#3b82f6" opacity="0.6" data-id="element-911" data-mp="oqs7ufmpquou" />
                <circle cx="310" cy="280" r="4" fill="#3b82f6" opacity="0.6" data-id="element-912" data-mp="29cgtrhksavyi" />
                <circle cx="700" cy="150" r="4" fill="#ef4444" opacity="0.6" data-id="element-913" data-mp="25891jaf4axvj" />
                <circle cx="680" cy="180" r="4" fill="#ef4444" opacity="0.6" data-id="element-914" data-mp="209pd93d1xa00" />
                <circle cx="720" cy="200" r="4" fill="#ef4444" opacity="0.6" data-id="element-915" data-mp="1vb4e779jcwd5" />
                <circle cx="650" cy="160" r="4" fill="#ef4444" opacity="0.6" data-id="element-916" data-mp="1vd8s8i15fbr5" />
                <circle cx="600" cy="250" r="4" fill="#ef4444" opacity="0.6" data-id="element-917" data-mp="2syd5jiw7wzn2" />
                <circle cx="620" cy="300" r="4" fill="#ef4444" opacity="0.6" data-id="element-918" data-mp="2o0ut3iizs2ab" />
                <circle cx="710" cy="350" r="4" fill="#ef4444" opacity="0.6" data-id="element-919" data-mp="2j8jssekcaeh8" />
                <circle cx="690" cy="280" r="4" fill="#ef4444" opacity="0.6" data-id="element-920" data-mp="2ea07mgdkl6px" />
                <circle cx="300" cy="220" r="4" fill="none" stroke="#3b82f6" strokeWidth="2" data-id="element-921" data-mp="2e7w625358jst" />
                <circle cx="350" cy="280" r="4" fill="none" stroke="#3b82f6" strokeWidth="2" data-id="element-922" data-mp="2fb30jc21llhn" />
                <circle cx="700" cy="220" r="4" fill="none" stroke="#ef4444" strokeWidth="2" data-id="element-923" data-mp="26ay4tz67objb" />
                <circle cx="650" cy="280" r="4" fill="none" stroke="#ef4444" strokeWidth="2" data-id="element-924" data-mp="2y2ng9dh2tzdn" />
              </svg>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-6" data-id="element-925" data-mp="2tzqu5csbvl4y">
            <div data-id="element-926" data-mp="2tyfplar269cs">
              <div className="font-semibold text-red-600 mb-2" data-id="element-927" data-mp="2u23j49wi6vri">
                Knicks Shots
              </div>
              <div className="space-y-2" data-id="element-928" data-mp="1iku1lswxqdsu">
                <label className="flex items-center space-x-2 cursor-pointer" data-id="element-929" data-mp="1ilvbvv64mw9i">
                  <input type="checkbox" checked={homeFilters.madeShots} onChange={() => setHomeFilters(prev => ({
                  ...prev,
                  madeShots: !prev.madeShots
                }))} className="rounded border-gray-300 text-red-600 focus:ring-red-500" data-id="element-930" data-mp="1a3a5rz37nq4r" />
                  <span className="text-sm" data-id="element-931" data-mp="rdv545rft30w">Made Shots</span>
                </label>
                <label className="flex items-center space-x-2 cursor-pointer" data-id="element-932" data-mp="mfjx80kpd2lb">
                  <input type="checkbox" checked={homeFilters.missedShots} onChange={() => setHomeFilters(prev => ({
                  ...prev,
                  missedShots: !prev.missedShots
                }))} className="rounded border-gray-300 text-red-600 focus:ring-red-500" data-id="element-933" data-mp="113er3kag5czz" />
                  <span className="text-sm" data-id="element-934" data-mp="1w07vrug255u5">Missed Shots</span>
                </label>
                <label className="flex items-center space-x-2 cursor-pointer" data-id="element-935" data-mp="1r3qvk1vl310p">
                  <input type="checkbox" checked={homeFilters.twoPoints} onChange={() => setHomeFilters(prev => ({
                  ...prev,
                  twoPoints: !prev.twoPoints
                }))} className="rounded border-gray-300 text-red-600 focus:ring-red-500" data-id="element-936" data-mp="1m333rdzj6g5f" />
                  <span className="text-sm" data-id="element-937" data-mp="13binnbgl408w">2PT Shots</span>
                </label>
                <label className="flex items-center space-x-2 cursor-pointer" data-id="element-938" data-mp="ygd7kt9v5fsq">
                  <input type="checkbox" checked={homeFilters.threePoints} onChange={() => setHomeFilters(prev => ({
                  ...prev,
                  threePoints: !prev.threePoints
                }))} className="rounded border-gray-300 text-red-600 focus:ring-red-500" data-id="element-939" data-mp="te5q5o69l7j0" />
                  <span className="text-sm" data-id="element-940" data-mp="3f0yon1ipv7ea">3PT Shots</span>
                </label>
              </div>
            </div>
            <div data-id="element-941" data-mp="2hdq9rpd80wl9">
              <div className="font-semibold text-blue-600 mb-2" data-id="element-942" data-mp="2he9ge9xf7yjz">
                Lakers Shots
              </div>
              <div className="space-y-2" data-id="element-943" data-mp="2md2vu7w9pzms">
                <label className="flex items-center space-x-2 cursor-pointer" data-id="element-944" data-mp="2rbe4wgeqo63y">
                  <input type="checkbox" checked={awayFilters.madeShots} onChange={() => setAwayFilters(prev => ({
                  ...prev,
                  madeShots: !prev.madeShots
                }))} className="rounded border-gray-300 text-blue-600 focus:ring-blue-500" data-id="element-945" data-mp="2r9b554nsaym1" />
                  <span className="text-sm" data-id="element-946" data-mp="1rk22560fu2wa">Made Shots</span>
                </label>
                <label className="flex items-center space-x-2 cursor-pointer" data-id="element-947" data-mp="25ax9uez7adya">
                  <input type="checkbox" checked={awayFilters.missedShots} onChange={() => setAwayFilters(prev => ({
                  ...prev,
                  missedShots: !prev.missedShots
                }))} className="rounded border-gray-300 text-blue-600 focus:ring-blue-500" data-id="element-948" data-mp="25crnd88573sc" />
                  <span className="text-sm" data-id="element-949" data-mp="1hl2y60qmavfm">Missed Shots</span>
                </label>
                <label className="flex items-center space-x-2 cursor-pointer" data-id="element-950" data-mp="2xz2wj79ted0r">
                  <input type="checkbox" checked={awayFilters.twoPoints} onChange={() => setAwayFilters(prev => ({
                  ...prev,
                  twoPoints: !prev.twoPoints
                }))} className="rounded border-gray-300 text-blue-600 focus:ring-blue-500" data-id="element-951" data-mp="2t0hx3a2dzxdd" />
                  <span className="text-sm" data-id="element-952" data-mp="ary6iss0mnau">2PT Shots</span>
                </label>
                <label className="flex items-center space-x-2 cursor-pointer" data-id="element-953" data-mp="yghgdcqpr851">
                  <input type="checkbox" checked={awayFilters.threePoints} onChange={() => setAwayFilters(prev => ({
                  ...prev,
                  threePoints: !prev.threePoints
                }))} className="rounded border-gray-300 text-blue-600 focus:ring-blue-500" data-id="element-954" data-mp="12i2ybci3ucm3" />
                  <span className="text-sm" data-id="element-955" data-mp="1m7v5zaxhcpmb">3PT Shots</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="w-56 shrink-0" data-id="element-956" data-mp="3or22nd7ol8d1">
          <div className="font-semibold text-blue-600 mb-3" data-id="element-957" data-mp="3oq0rl8qo0lvb">
            Los Angeles Lakers
          </div>
          <div className="space-y-2" data-id="element-958" data-mp="3kpqk1rn85nec">
            {awayPlayers.map(player => <label key={player.number} className="flex items-center space-x-3 cursor-pointer" data-id="element-959" data-mp="3fr5gpjcoenlo">
                <input type="checkbox" checked={selectedAwayPlayers.includes(player.name)} onChange={() => toggleAwayPlayer(player.name)} className="rounded border-gray-300 text-blue-600 focus:ring-blue-500" data-id="element-960" data-mp="gctechc6z3qo" />
                <span className="text-sm" data-id="element-961" data-mp="2hrcq6edo0jo">
                  #{player.number} {player.name}
                </span>
              </label>)}
          </div>
        </div>
      </div>
    </div>;
};
export default ShootingChart;